<template>
  <v-container>
    <v-row v-if="false" justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
          disabled
        >
          Añadir Extension
        </v-btn>
      </v-col>
    </v-row>

    <!-- show-expand
        single-expand -->
    <br />

    <v-data-table
      :headers="headers"
      :items="tableList"
      item-key="id"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleChangeKey(item)"
          >
            <v-icon>mdi-key-arrow-right</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleShowKey(item)"
          >
            <v-icon>mdi-key-variant</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>
    <form-dialog
      :dataToEdit="itemSelected"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      @dialog:close="closeFormDialog"
    ></form-dialog>
    <change-key-dialog
      :isActive="isOpenChangeKeyForm"
      :extension="itemSelected.name"
      @dialog:close="isOpenChangeKeyForm = false"
    ></change-key-dialog>
    <key-dialog
      :isActive="isOpenKeyForm"
      :extension="itemSelected"
      @dialog:close="closeKeyDialog"
    ></key-dialog>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import FormDialog from "./FormDialog.vue";
import KeyDialog from "./KeyDialog.vue";
import ChangeKeyDialog from "./ChangeKeyDialog.vue";

export default {
  components: { FormDialog, KeyDialog, ChangeKeyDialog },
  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isOpenKeyForm: false,
    isOpenChangeKeyForm: false,
    isEditMode: false,
    tableList: [],
    itemSelected: {},
    headers: [
      {
        text: "Extension",
        align: "left",
        value: "extension",
        class: "primary--text",
        width: "40%",
      },
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "40%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "20%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  created() {
    this.getExtensions();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    openKeyDialog() {
      this.isOpenKeyForm = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.itemSelected = item;
      this.openFormDialog();
    },

    handleChangeKey(item) {
      this.itemSelected = item;
      this.isOpenChangeKeyForm = true;
    },

    async handleShowKey(item) {
      this.itemSelected = item;
      this.openKeyDialog();
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.tableList = this.tableList.map((el) =>
          el.extension === data.extension ? data : el
        );
      if (data && !this.isEditMode) this.tableList = [...this.tableList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.itemSelected = {};
    },

    closeKeyDialog() {
      this.isOpenKeyForm = false;
      this.itemSelected = {};
    },

    async getExtensions() {
      this.isLoading = true;

      // const { page, itemsPerPage } = this.options;
      try {
        const res = await PbxHttpClient.get(`/server_externo/extension/list`);

        this.tableList = res.data.data;
      } catch (error) {
        // console.error(error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
